import { render, staticRenderFns } from "./ProtectionAreaForm.vue?vue&type=template&id=a8805556"
import script from "./ProtectionAreaForm.vue?vue&type=script&lang=js"
export * from "./ProtectionAreaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports